export const OtherFormOfTeachingId = 8;
export const OtherKnowledgeCheckId = 6;